<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 操作按钮 -->
            <div class="search-bar">
                <el-button :icon="Refresh" @click="handler.queryHandler">刷新数据</el-button>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="premissionTreeData" v-loading="tableLoading" height="100%" row-key="id"
                    ref="dataTableRef" class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }">
                    <el-table-column type="selection" width="40" />
                    <el-table-column prop="funName" label="菜单名称" width="180" />
                    <el-table-column prop="funVal" label="菜单URL" />
                    <el-table-column prop="funType" label="类型" width="80" />
                    <el-table-column prop="icon" label="图标" width="150" />
                    <el-table-column prop="orderSn" label="排序号" width="70" />
                    <el-table-column prop="modifyName" label="修改人" width="100" />
                    <el-table-column prop="modifyDate" label="修改日期" width="180">
                        <template #default="scope">
                            <span>{{ utils.formatDate(scope.row.modifyDate, "YYYY-MM-DD HH:mm:ss") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="110" fixed="right" header-align="center">
                        <template #default="scope">
                            <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                            <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="700" append-to-body="true">
            <el-form :inline="true" :model="form" label-position="left" label-width="auto" :rules="rules" status-icon
                ref="dataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item label="菜单名" prop="funName">
                    <el-input v-model="form.funName" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="父级菜单" prop="parentId">
                    <el-tree-select v-model="form.parentId" :data="premissionTreeData" :props="{ label: 'funName', value: 'id' }"
                        check-strictly render-after-expand="true" class="el-input-width" placeholder="请选择" />
                </el-form-item>
                <el-form-item label="菜单URL" prop="funVal">
                    <el-input v-model="form.funVal" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="图标" prop="icon">
                    <el-input v-model="form.icon" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="排序号" prop="orderSn" required>
                    <el-input v-model.number="form.orderSn" autocomplete="off" class="el-input-width" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.saveHandler">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from 'vue';
import "@/assets/styles/crud-page.css";
import { ElTable, ElMessageBox, ElMessage } from 'element-plus';
import { Delete, CirclePlusFilled, Edit, Refresh } from '@element-plus/icons-vue';
import utils from "@/utils/utils.js";
import { permissionApi } from '@/api/permission-api.js';

//弹出框状态
const dialogFormVisible = ref(false);
const tableLoading = ref(false);

//数据
const premissionTreeData = ref([]);

//控件引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);

//表单
const form = reactive({
    id: '',
    parentId: -1,
    funName: '',
    funType: '',
    funVal: '',
    icon: '',
    orderSn: ''
});
const resetForm = () => {
    dataFormRef.value?.resetFields();
};
const rules = {
    funName: [
        { required: true, message: '菜单名不能为空', trigger: 'blur' }
    ],
    parentId: [
        { required: true, message: '请选择父级菜单', trigger: 'blur' }
    ],
    orderSn: [
        { required: true, message: '排序号不能为空', trigger: 'blur' },
        { type: 'number', message: '排序号必须是数字', trigger: ['blur', 'change'] },
    ]
};

//生命周期
onMounted(() => {
    handler.queryHandler();
})

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        permissionApi.getPermissionsPage().then((response) => {
            if (response.data.errorCode === "00000") {
                premissionTreeData.value = response.data.result;
            } else {
                ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
            }
        })
            .finally(function () {
                tableLoading.value = false;
            });
    },
    addHandler() {
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        })
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                permissionApi.deletePermission([rowObj.id])
                    .then((response) => {
                        if (response.data.errorCode === "00000") {
                            ElMessage({ message: '删除成功.', type: 'success' });
                            handler.queryHandler();
                            this.dialogFormVisible = false;
                        } else {
                            ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                        }
                    })
            }).catch(() => {})
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) { ElMessage("没有选中任何行"); return; }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                permissionApi.deletePermission(ids)
                    .then((response) => {
                        if (response.data.errorCode === "00000") {
                            ElMessage({ message: '删除成功.', type: 'success' });
                            handler.queryHandler();
                        } else {
                            ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                        }
                    })
            }).catch(() => {})
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                permissionApi.savePermission(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                    }
                })
            }
        });
    }
}
</script>
